module.exports = __webpack_public_path__ + "static/app-dev-mobile-b66583f477c080cfbc48d8d9f2fd3ff1.jpg";